module.exports = __webpack_public_path__ + "img/logo.422314e8.png";